import React, { FC } from 'react'
import { useDispatch, useSelector } from '../../store/index'
import { goBack } from 'connected-react-router'
import CustomButton from '../../components/UI/Buttons/CustomButton'
import BackIcon from '../../components/UI/Icons/Back';
import { useMemo } from 'react'
import { logOutThunk } from '../../store/auth/thunks'
import { push } from 'connected-react-router'
import TermsAndConditions from '../../components/TermsAndConditions'
import Logo from '../../assets/img/brand/logo-medium.png'

type OnboardingStepProps = {}

const OnboardingStep: FC<OnboardingStepProps> = (props) => {
  const { location } = useSelector(({ router: { location } }) => ({ location }))

  const backButtonVisibled = useMemo(() => {
    const result = location.pathname.split('/')
    if (result[1] === 'create-project' || result[1] === 'reset-password' || result[1] === 'without-project') return false
    // else if (result[1] === 'create-agency' && result[2] === '1') return false
    return true
  }, [location])

  const showTermsCondition = useMemo(() => {
    const result = location.pathname.split('/')
    if (result[1] === 'add-card') return true
    return false
  }, [location])

  const dispatch = useDispatch()
  const moveBack = async () => {
    const result = location.pathname.split('/')
    if (result && result[1] === 'add-card') {
      await dispatch(logOutThunk())
      dispatch(push('/signup'))
    } else {
      dispatch(goBack())
    }
  }
  return (
    <>
      <div className='create-agency'>
        <div className='create-agency__move-back'>
          {backButtonVisibled && (
            <CustomButton button='move' className='arrow-left' onClick={moveBack}>
              <BackIcon /> <span className="create-agency__move-back__pl-5">Back</span>
            </CustomButton>
          )}
        </div>
        <div className="create-agency_logo-holder">
          <img className="create-agency__logo__image" src={Logo} />
        </div>
        <div className='create-agency__content'>
          {props.children}
        </div>
        {showTermsCondition ? <div className="create-agency__terms_condition"><TermsAndConditions text="By entering your payment details, you agree with our" /></div> : null}
      </div>

    </>
  )
}

export default OnboardingStep
